<template>
  <v-app>
    <v-app-bar app clipped-left color="primary">
      <v-app-bar-nav-icon @click.stop="nav.show = !nav.show"></v-app-bar-nav-icon>
      <v-toolbar-title class="headline text-uppercase">
        <span class="font-weight-light">CHome Rent System</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div v-if="printer.connected" class="ptrbatt">
        <v-progress-linear
          :value="printer.battery"
          color="success"
          height="8"
          rounded
        >
          <template v-slot="{ value }">
            <v-icon v-if="printer.charging">battery_charging_full</v-icon>
          </template>
        </v-progress-linear>
      </div>
      <v-btn v-if="printer.available" icon @click="togglePrinter">
        <v-icon v-if="printer.connected">print</v-icon>
        <v-icon v-else>print_disabled</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer
      v-model="nav.show"
      app
      clipped
    >
      <v-list nav dense>
        <v-list-item-group v-model="nav.index">
          <v-list-item
            v-for="(item, i) in nav.items"
            :key="i"
            :to="item.route"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-content>
      <router-view :printer="printer"></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  methods: {
    togglePrinter() {
      if (!this.printer.available) return;
      const p = window.paperang;
      if (p.isConnected()) {
        p.disconnect();
      } else {
        p.connect();
      }
    },
    updatePrinterStatus() {
      if (!this.printer.available) return;
      const p = window.paperang;
      this.printer.connected = p.isConnected();
      if (this.printer.connected) {
        p.getBattery();
      }
    },
  },
  created() {
    if (typeof window.paperang !== "undefined") {
      window.paperangRecvCallback = (cmd, data) => {
        switch(cmd) {
          case "BATT":
            this.printer.battery = data;
            break;
        }
      };
      const p = window.paperang;
      p.registerCallback("paperangRecvCallback");
      this.printer.available = true;
      setInterval(() => {
        this.updatePrinterStatus();
      }, 5000);
    }
  },
  data: () => ({
    printer: {
      available: false,
      connected: false,
      battery: 0,
      charging: false,
      large: true,
    },
    nav: {
      show: false,
      index: 0,
      items: [
        {
          icon: "assignment",
          text: "抄表",
          route: "/meter/",
        },
        {
          icon: "assignment",
          text: "抄表M",
          route: "/meterm/",
        },
      ],
    },
  }),
};
</script>

<style>
.v-application {
  font-family: 'Noto Sans TC', sans-serif !important;
}

.ptrbatt {
  width: 24px;
}
</style>

